import React from "react";
import FormAutocomplete from "app/components/form-components/FormAutocomplete";
import FormTextField from "app/components/form-components/FormTextField";
import { Grid } from "@mui/material";
import { EmploymentTypes, QualificationOptions } from "../../Constants";
function AddQualificationRequirement({ control, preloadedData }) {
  return (
    <Grid container spacing={3}>
      {/* Employment Type */}
      <Grid item xs={12} md={3}>
        <FormAutocomplete
          control={control}
          name={"jp_type"}
          label={"Employment Type *"}
          sxValues={{ width: "100%", mb: 0 }}
          defaultValue={preloadedData ? preloadedData.jp_type : ""}
          values={EmploymentTypes}
          helperText={"Employment type is required"}
        />
      </Grid>
      {/* Qualification */}
      <Grid item xs={12} md={3}>
        <FormAutocomplete
          control={control}
          defaultValue={preloadedData ? preloadedData.jp_qualification : ""}
          name={"jp_qualification"}
          sxValues={{ width: "100%", mb: 0 }}
          label={"Highest Education Level *"}
          values={QualificationOptions}
          helperText={"Education level is required"}
        />
      </Grid>
      {/* Required Degree */}
      <Grid item xs={12} md={6}>
        <FormTextField
          control={control}
          fullWidth
          name={"jp_required_degree"}
          defaultValue={preloadedData ? preloadedData.jp_required_degree : ""}
          label={"Required Degree *"}
          helperText={"Degree is required"}
        />
      </Grid>
    </Grid>
  );
}

export default AddQualificationRequirement;
